import React from 'react';

interface GlobalLoaderProps {
    fullScreen?: boolean;
    message?: string;
}

export const GlobalLoader: React.FC<GlobalLoaderProps> = () => {
    return null;
};
